// Yazdırma (DAL api/print): yazıcı adı sunucuda çözülür — ajan yazıcısıysa PDF o bilgisayara
// gider, değilse Worker görevi açılır. İstemci artık görev tablosuna kendisi yazmaz.
// Her ajan işi Tb_Rn_Sys_DevicePrintJobs'a yazılır: cihaz çevrimdışıysa kuyrukta bekler (queued).
import { apiClient } from './http/client';
import { ENDPOINTS } from './endpoints';

export interface PrintReportParameter {
  fieldName: string;
  /** "=" ya da "IN" */
  filterOperatorType: string;
  value: string | null;
}

export interface PrintReportRequest {
  reportId: string;
  /** @local, takma ad (DEPO-ETIKET), CIHAZ/Yazıcı ya da sunucu yazıcı adı */
  printerName: string;
  copies: number;
  /** Bu bilgisayarın ajanı (whoami); @local bununla çözülür */
  localDeviceId?: string | null;
  parameters: PrintReportParameter[];
  /** Denetim kaydı için işlemi başlatan ekran nesnesi */
  objectId?: string | null;
  title?: string | null;
  /** Cihaz çevrimdışıysa kuyruğa al (varsayılan true); false → hemen hata */
  queueIfOffline?: boolean;
}

export interface PrintResponse {
  routed: 'device' | 'worker';
  success: boolean;
  message: string | null;
  /** Cihaz çevrimdışıydı, iş kuyruğa alındı (bağlanınca basılır) */
  queued?: boolean;
  jobId?: string | null;
  deviceCode?: string | null;
  printerName?: string | null;
  reportName?: string | null;
  workerTaskId?: number | null;
  pageCount?: number;
}

export type PrintJobState = 'Queued' | 'Sent' | 'Done' | 'Failed' | 'Expired';

export interface PrintJobDto {
  devicePrintJobId: string;
  deviceId: string;
  deviceCode: string;
  printerName: string;
  kind: 'Pdf' | 'Raw';
  copies: number;
  title: string | null;
  state: PrintJobState;
  attempts: number;
  lastError: string | null;
  source: 'User' | 'Worker' | string;
  reportId: string | null;
  addDate: string;
  sentUtc: string | null;
  completedUtc: string | null;
  expiresUtc: string;
  size: number;
}

export const printApi = {
  printReport: (request: PrintReportRequest) =>
    apiClient.post<PrintResponse>(ENDPOINTS.PRINT_REPORT, request, { octo: { expectSuccess: false } }),
  printRaw: (request: { printerName: string; dataBase64: string; copies?: number; localDeviceId?: string | null; title?: string | null; queueIfOffline?: boolean }) =>
    apiClient.post<PrintResponse>(ENDPOINTS.PRINT_RAW, request, { octo: { expectSuccess: false } }),
  /** Kuyruk + geçmiş (son N iş); deviceId ve state ile süzülür. */
  jobs: (params: { deviceId?: string; state?: PrintJobState; take?: number } = {}) =>
    apiClient.get<PrintJobDto[]>(ENDPOINTS.PRINT_JOBS, { params, octo: { expectSuccess: false } }),
  /** Bekleyen (Queued) işi iptal eder. */
  cancelJob: (jobId: string) => apiClient.delete<{ success: boolean }>(ENDPOINTS.PRINT_JOB(jobId), { octo: { expectSuccess: false } }),
};
